import {Component, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { User } from "projects/store/src/app/interfaces";
import {environment} from "projects/store/src/environments/environment";

@Component({
  selector: 'app-check-user',
  templateUrl: './check-user.component.html'
})
export class CheckUserComponent implements OnInit {
  token: string;
  intervalTime: number = 2000;

  @Input() user!: User;
  @Output() response: any = new EventEmitter();

  constructor(private renderer: Renderer2,
              private router: Router,
              private route: ActivatedRoute) {
    this.token = this.route.snapshot.queryParams['token'];
  }

  ngOnInit() {
    this.load();
  }

  load() {
    const metadata = this.user;

    const container = this.renderer.createElement('kyc-button');
    this.renderer.setAttribute(container, 'id', 'face-recognition');
    this.renderer.setAttribute(container, 'metadata', JSON.stringify(metadata));
    this.renderer.setAttribute(container, 'origin_image_url', JSON.stringify(this.user.selfie_photo_url));
    this.renderer.appendChild(document.getElementById("kyc-button-container"), container);

    const containerScript = this.renderer.createElement('script');
    this.renderer.setProperty(containerScript, 'type', 'text/javascript');
    this.renderer.setProperty(containerScript, 'src', environment.kycSiteURL+'assets/load-kyc.js');
    this.renderer.appendChild(document.getElementById("kyc-button-container"), containerScript);

    this.checkIframe();
  }

  checkIframe() {
    let interval = setInterval(() => {
      if(document.getElementById('kyc-krediya') == null) {
        this.response.emit();
        clearInterval(interval);
      }
    }, this.intervalTime);
  }
}
